<template>
    <div class="AboutChinaPostalAirlines">
        <div class="g-s-a-w">
            <div class="news_image"></div>
        </div>
        <div class="content">
            <h2 class="title">About China Postal Airlines</h2>
            <div>
                China Postal Airlines Limited Liability Company (hereinafter referred to as "CPA"), 
                a wholly-owned subsidiary of China Post Group Limited Company, was established on November 25th, 1996, 
                and officially commenced operations on February 27th, 1997. As the first domestic airline specializing in express mail and cargo transportation,
                CPA is a CCAR-121 public air transport enterprise and a formal member of the International Air Transport Association (IATA).
                Its main operating base is in Beijing, with Nanjing serving as the hub.
            </div>
            <div>
                Currently, CPA owns 41 aircraft, including 2 B777 freighters, 7 B757 freighters,
                and 32 B737 freighters (15 B737-300/400 freighters and 17 B737-800 freighters).
                It operates 48 routes with an average of 80 flights per day, connecting 38 destinations (including 33 domestic destinations and 5 international/regional destinations).
                Adopting a "full-night flight" model combining hub-and-spoke distribution with direct flights,
                CPA centers its operations around Nanjing for distribution, while offering direct point-to-point services in key cities such as Beijing,
                Shanghai, Hangzhou, Guangzhou, and Shenzhen. This has formed a route network covering major cities in China, Seoul, Osaka, Tokyo, and Manila,
                providing high-quality and reliable air transport support for China Post's express delivery network. CPA has become a core asset, core value,
                and competitive edge of China Post EMS.
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AboutChinaPostalAirlines',
        
    }
</script>

<style lang="scss" scoped>
.AboutChinaPostalAirlines {
    background: #f7f8fa;
    padding-bottom: 55px;
}
.news_image {
    width: 1200px;
    height: 600px;
    margin: 0 auto 23px;
    background: url("~@/assets/img/Abouts/Airlines.jpg") 0px -238px/100% no-repeat;
}
.content {
    width: 1200px;
    margin: 0 auto;
    background: white;
    padding: 37px 48px;
    font-size: 20px;
    line-height: 40px;
    text-indent: 2em;
    .title {
        text-align: center;
        font-size: 30px;
        margin-bottom: 20px;
    }
}
</style>